<template>
  <div class="pageContent">
    <!--顶部一条-->
    <mu-appbar>
      <span class="topT">银联支付</span>
      <!--返回上一层-->
      <mu-icon value="keyboard_arrow_left" color="white" style="margin-bottom: -0.05rem" slot="left" v-on:click="goback" />
      <mu-icon value="keyboard_arrow_left" color="#27ba69" slot="right" />
    </mu-appbar>

    <div style="width:100% ; margin-top:0.3rem" align="center">

      <!--<div style="width:92% ; text-align:left ; font-size:0.32rem ;  ">
            <span style=" color:#666 ; font-weight:bold ; float:left ; margin-top : 0.15rem ">银行卡</span>
            <span style="width:0.3rem ; float:left" >  &nbsp; </span>
              
              <mu-select-field v-model="ChooseCard"  :underlineShow ="false"  hintText="选择您的银行卡"  style="width: 5rem ; min-height:0.7rem ; float:left  " 
                class="thisselect"  >
                <mu-menu-item v-for="text,index in Cards" :key="index" :value="index" :title="text" />
              </mu-select-field>
          </div>-->

      <div style="width:92% ; text-align:left ;  margin:0.2rem 0 0.2rem 0">
        <span style=" color:#666666 ;font-size:0.3rem ; ">卡号</span>
        <span style="margin-left:0.3rem ;  font-weight:bold ;color:#333333 ;font-size:0.3rem ; ">
          {{ g_PayOrder.CardReplace }}( {{  g_PayOrder.BankName }}{{  g_PayOrder.CardType }} )
        </span>
      </div>
      <mu-divider style="width:92%" />

      <div style="width:92% ; text-align:left ;  margin:0.2rem 0 0.2rem 0">
        <span style=" color:#666666 ;font-size:0.3rem ; ">金额</span>
        <span style="margin-left:0.6rem ;  font-weight:bold ;color:#333333 ;font-size:0.3rem ; ">
          ￥ {{ g_PayOrder.Money }}
        </span>
      </div>
      <mu-divider style="width:92%" />

      <div style="width:92% ; text-align:left ;  margin:0.2rem 0 0.2rem 0">
        <span style=" color:#666666 ;font-size:0.3rem ; ">手机</span>
        <span style="margin-left:0.6rem ;  font-weight:bold ;color:#333333 ;font-size:0.3rem ; ">
          {{ OutPhone }}
        </span>
      </div>
      <mu-divider style="width:92%" />

      <!--<div style="width:92% ; text-align:left ;  margin:0.2rem 0 0.2rem 0">
          <span style=" color:#666666 ;font-size:0.3rem ; ">附加码</span>
          <input v-model="FJM" style=" margin-left:0.3rem  ;  border:0 ; outline:0 ;   font-size:0.3rem ; width: 3rem" placeholder="请输入附加码" />
          <img v-bind:src="TPFJM" style="width:24% ; margin-left:2% ; margin-bottom:-2%" v-on:click="this.getValidateCode" align="right" />
        </div>
        <mu-divider style="width:92%" />-->

      <div style="width:92% ; text-align:left ;  margin:0.2rem 0 0.2rem 0">
        <span style=" color:#666666 ;font-size:0.3rem ; ">验证码</span>
        <input v-model="YZM" style="  margin-left:0.3rem  ;  border:0 ; outline:0 ;    font-size:0.3rem ; width: 3rem" placeholder="请输入验证码" />
        <!--<input type="button" value="获取" v-on:click="getYZM" style="fnt-size:0.3rem ; margin-bottom:-0.2rem ; margin-top:-0.05rem ;  background-color:#27ba69 ; height: 0.6rem  ;  border:none  ;  width: 1.65rem ; color:white ; float:right  " />-->

        <span v-on:click="getYZM" v-show="haveYZM == false">
          <input type="button" value="获取" style=" margin-top:-0.1rem ; font-size:0.32rem ; float:right ; background-color:#27ba69 ; color:white; height: 0.7rem  ; border:none  ;  width: 30% ; " />
        </span>
        <span   v-show="haveYZM == true">
          <input type="button" v-model="WaitTime" style="  margin-top:-0.1rem ; font-size:0.32rem ; float:right ;   background-color:#eeeeee ;  color:#999 ;  height: 0.7rem  ; border:none  ;  width: 30% ;" />
        </span>

      </div>
      <mu-divider />

      <mu-raised-button label="下一步" primary="" v-bind:style="{ width:'92%', height:'0.9rem' }" style="font-size: 0.3rem ; margin-top:0.3rem ; " v-on:click="goPay" />

      <mu-divider style="margin-top:0.7rem  ;   margin-bottom:0.2rem ; width:92%" />

      <table style="width:92% ; font-size:0.24rem ; color:#666666 " border="0">
        <tr>
          <td style="width:0.3rem"> · </td>
          <td>
            格林豪泰酒店不会记录您任何银行卡信息，
          </td>
          <td rowspan="3">
            <img src="../../../../static/order/YinLian-Big.png" style=" width:1.5rem " />

          </td>
        </tr>
        <tr>
          <td> </td>
          <td> 所有信息均由加密通道传递给中国银联
            <br />
            <br /> </td>
        </tr>
        <tr>
          <td> · </td>
          <td>
            本服务由银联在线提供技术支持
          </td>
        </tr>
      </table>

      <mu-divider style="margin-top:0.2rem  ;; width:92%" />

    </div>

    <!--弹出框 选择是否-->
    <mu-dialog :open="dialog" title="" @close="closeNO">
      <div style="color:#666666">
        尊敬的客户，您确定取消订单吗？
      </div>
      <table style="width:100%">
        <tr>
          <td align="center">
            <mu-flat-button slot="actions" @click="closeNO" primary="" label="取消" style="background-color:#cccccc ;color:white  " />
          </td>
          <td align="center">
            <mu-flat-button slot="actions" @click="closeYES" label="确定" style="background-color:#27BA69 ;;color:white " />
          </td>
        </tr>
      </table>
    </mu-dialog>

    <!--弹出框-->
    <mu-toast v-if="toast" v-bind:message="TellUser" @close="hideToast" id="alertline" />

  </div>
</template>







<script>


import { mapMutations, mapGetters } from 'vuex'
import api from '../../../api'



export default {
  computed: {
    ...mapGetters([
      'g_UserInfo', 'g_PayOrder'
    ])
  },
  activated() {

    this.Ispay = false;
        this.YZM = '';
        this.FJM = '';
    this.init();
  },
  data() {
    return {

      haveYZM: false,
      WaitTime: '',
      CloseTime: 29,

      OutPhone:'',
      // number: '',

      // 弹出层
      TellUser: '',
      toast: false,
      // 弹出标签 选择是否
      dialog: false,

      //  表单信息
      TPFJM: "",
      FJM: "",
      YZM: "",

    }
  },
  methods: {
    ...mapMutations([
      'setG_currentOrder', 'setG_PayOrder'
    ]),



    init() {
      this.getValidateCode();


      if (this.g_PayOrder.CardType == "信用卡")
        this.InitOrderUnionPayCreditCard();
      if (this.g_PayOrder.CardType == "借记卡")
        this.InitOrderUnionPayDebitCard();
    },

    // 页面初始化时，获取手机号
    InitOrderUnionPayCreditCard() {   //可以获取  Message: "订单状态不为预订状态"}  无需
      var params = new this.URLSearchParam();
      params.append('parentNo', this.g_PayOrder.OrderId);
      params.append('bankCard', this.g_PayOrder.CardNo);
      params.append('payMoney', this.g_PayOrder.Money);
      // params.append('orderType', this.$route.query.orderType);
      params.append('orderType', this.g_PayOrder.TypeId)
      

      this.$http.post(api.InitOrderUnionPayCreditCard(this.g_PayOrder.PayFor), params.toParam()).then((res) => {
        console.log(res)

        if (res.Result) {

          this.OutPhone = res.Data.ReservePhone;

          // 更新价格
          var Order = this.g_PayOrder;

          Order.Phone = res.Data.ReservePhone;
          Order.Money = res.Data.PayMoney;
          this.setG_PayOrder(Order);
        }
        else {
          this.TellUser = res.Message;
          this.showToast();
        }

      })
    },
    InitOrderUnionPayDebitCard() {   //可以获取  Message: "订单状态不为预订状态"}  无需
      var params = new this.URLSearchParam();
      params.append('parentNo', this.g_PayOrder.OrderId);
      params.append('bankCard', this.g_PayOrder.CardNo);
      params.append('payMoney', this.g_PayOrder.Money);
      params.append('orderType', this.g_PayOrder.TypeId)
      this.$http.post(api.InitOrderUnionPayDebitCard(this.g_PayOrder.PayFor), params.toParam()).then((res) => {
        console.log(res)

        if (res.Result) {
          var Order = this.g_PayOrder;

          Order.Phone = res.Data.ReservePhone;
          Order.Money = res.Data.PayMoney;
          this.setG_PayOrder(Order);
        }
        else {
          this.TellUser = res.Message;
          this.showToast();
        }
      })
    },


    //  获取验证码 - 借记卡

    GetValidateCodeForDebitPay() {   //   获取验证码 - 借记卡
      var params = new this.URLSearchParam();
      params.append('parentNo', this.g_PayOrder.OrderId);
      params.append('bankCard', this.g_PayOrder.CardNo);
      params.append('phoneNo', this.g_PayOrder.Phone);
      params.append('orderType', this.g_PayOrder.TypeId)
      this.$http.post(api.GetValidateCodeForDebitPay(this.g_PayOrder.PayFor), params.toParam()).then((res) => {
        console.log(res)

        if (res.Result) {
          this.TellUser = "短信已发送";
          this.showToast();
        }
        else {
          this.TellUser = res.Message;
          this.showToast();
        }
      })
    },

    // 获取 信用卡支付的的短信验证码
    GetValidateCodeForCreditPay() {
      if (this.g_PayOrder.Phone != undefined & this.g_PayOrder.Phone.length < 9) {
        this.TellUser = "请输入手机号";
        this.showToast();
        return;
      }
      var params = new this.URLSearchParam();
      params.append('parentNo', this.g_PayOrder.OrderId);
      params.append('bankCard', this.g_PayOrder.CardNo);
      params.append('phoneNo', this.g_PayOrder.Phone);

      this.$http.post(api.GetValidateCodeForCreditPay(this.g_PayOrder.PayFor), params.toParam()).then((res) => {
        console.log(res)

        if (res.Result) {
          this.TellUser = "短信已发送";
          this.showToast();
        }
        else {
          this.TellUser = res.Message;
          this.showToast();
        }
      })
    },



    //  获取验证码
    getYZM() {

      // 开始计时
      this.haveYZM = true;
      this.WaitTime = this.CloseTime + "秒"
      this.timer();

      if (this.g_PayOrder.CardType == "信用卡")
        this.GetValidateCodeForCreditPay();
      if (this.g_PayOrder.CardType == "借记卡")
        this.GetValidateCodeForDebitPay();
      this.getValidateCode();
      // }

    },
    timer() {
      if (this.CloseTime > 0) {
        this.CloseTime--;
        this.WaitTime = this.CloseTime + "秒"
        
        setTimeout(this.timer, 1000);
      }
      else if (this.CloseTime == 0) {
        this.haveYZM = false;
        this.CloseTime = 29;
      }
    },
    //  获取验证码  END



    // 付钱了  非第一次
    PayByUnionPayCreditCard() {    // 信用卡  
      var params = new this.URLSearchParam();
      params.append('accountCardNumber', this.g_PayOrder.CardNo);
      params.append('mobile', this.g_PayOrder.Phone);
      params.append('smsVerificationCode', this.YZM);
      params.append('orderId', this.g_PayOrder.OrderId);
      params.append('totalPrice', this.g_PayOrder.Money);
      params.append('orderType', this.g_PayOrder.TypeId)
      this.$http.post(api.PayByUnionPayCreditCard(this.g_PayOrder.PayFor), params.toParam()).then((res) => {
        console.log(res)

        if (res.Result) {
          this.TellUser = res.Data;
          this.showToast();

          this.toastTimer1 = setTimeout(() => {
            this.$router.push({
              path: '/order/PayIsOk?result=true&money=' + this.g_PayOrder.Money + '&parentNo=' + this.g_PayOrder.OrderId
              + '&paytype=银联支付&payDate=' + Date.prototype.NowDate()+'&orderType='+ this.g_PayOrder.TypeId
            });
          }, 1800);
        }
        else {
          this.Ispay = false;

          this.TellUser = res.Message;
          this.showToast();
        }
      })
    },

    PayByUnionPayDebitCard() {   //  借记卡 付钱
      var params = new this.URLSearchParam();
      params.append('accountCardNumber', this.g_PayOrder.CardNo);
      params.append('mobile', this.g_PayOrder.Phone);
      params.append('smsVerificationCode', this.YZM);
      params.append('orderId', this.g_PayOrder.OrderId);
      params.append('totalPrice', this.g_PayOrder.Money);
      params.append('orderType', this.g_PayOrder.TypeId)
      this.$http.post(api.PayByUnionPayDebitCard(this.g_PayOrder.PayFor), params.toParam()).then((res) => {
        console.log(res)

        if (res.Result) {
          this.TellUser = res.Data;
          this.showToast();

          this.toastTimer1 = setTimeout(() => {
            this.$router.push({
              path: '/order/PayIsOk?result=true&money=' + this.g_PayOrder.Money + '&parentNo=' + this.g_PayOrder.OrderId
              + '&paytype=银联支付&payDate=' + Date.prototype.NowDate()+'&orderType='+ this.g_PayOrder.TypeId
            });
          }, 1800);
        }
        else {
          this.Ispay = false;

          this.TellUser = res.Message;
          this.showToast();
        }
      })
    },
    // 交易失败：重复交易
    goPay() {

      if(this.Ispay == true){
        this.TellUser = '正在支付中。。。';
        this.showToast();
        return
      }

      if (this.YZM == '') {
        this.TellUser = '请输入验证码';
        this.showToast();
      }
      else {

        this.Ispay = true;

        if (this.g_PayOrder.CardType == "信用卡")
          this.PayByUnionPayCreditCard();
        if (this.g_PayOrder.CardType == "借记卡")
          this.PayByUnionPayDebitCard();
        this.getValidateCode();
      }

    },


    // 图片验证码
    getValidateCode() {
      this.TPFJM = api.getValidateCode();
    },


    goback() {
      javascript: history.go(-1);
    },

    // 弹出层
    showToast() {
      this.hideToast();
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, 1200)
      if (this.TellUser == '未登录') {
        this.$http.post(api.LogOff()).then((res) => { });
        this.$store.dispatch('clearUser');
        this.toastTimer = setTimeout(() => { this.$router.push({ path: '/user/login' }); }, 1600)
      }
      if (this.TellUser == '交易失败：重复交易') {
        this.toastTimer = setTimeout(() => { this.$router.push({ path: '/home/order' }); }, 1600)
      }
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
    // 弹出层  end
    // 弹出标签 选择是否
    open() {
      this.dialog = true
    },
    closeYES() {
      this.dialog = false;
      //调用弹出层
      this.showToast();
    },
    closeNO() {
      //  拒绝取消订单
      this.dialog = false;
    },
    // END 弹出标签 选择是否

  },
 




}
</script>




// paper模块
<style lang="less"  >
@import "../../../assets/theme.less";

.mu-text-field {
  min-height: 0px
}

.thisselect {
  height: 0px;

  .mu-text-field-content {
    padding-bottom: 0
  }
}



.green {
  color: @primaryColor ;
  border: 1px solid @primaryColor ;
}

.pageContent {
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;

  color: @textColor; // 顶部标签变换
  .header {
    width: 100%
  }
  .mu-tabs {
    // 背景色
    background-color: #fff;
  } // 未选中时候的颜色
  .mu-tab-link {
    color: #999999;
    font-weight: bold;
  } //  选中  分页的
  .mu-tab-active {
    color: @primaryColor;
    font-weight: bold;
  } // END 顶部标签变换
  .Orange {
    color: @primaryOrange ;
  }
  .Black {
    color: @primaryBlack ;
  }
  .Grey {
    color: @textColor;
  }
}
</style>





// WEBPACK FOOTER //
// DirectPay.vue?469c19d7